export default {
	Background: 'Background',
	Biography: 'Biography',
	Training: 'Training',
	EducationAndExperience: 'Education & Experience',
	BoardCertifications: 'Board Certifications',
	Introduction: 'Introduction',
	AcceptingNewPatients: 'Accepting New Patients',
	Gender: 'Gender',
	NotAcceptingNewPatients: 'Not Accepting New Patients',
	Locations: 'Locations',
	Insurance: 'Insurance',
	RatingAndReviews: 'Rating & Reviews',
	Ratings: 'Ratings',
	Specialties: 'Specialties',
	Languages: 'Languages',
	PatientReviews: 'Patient Reviews',
	OverallRating: 'Overall Rating',
	Reviews: 'Reviews',
	// Profile action blocks
	Call: 'Call',
	Contact: 'Contact',
	CopyLink: 'Copy Link',
	Directions: 'Directions',
	Miles: 'Miles',
	Print: 'Print',
	ScheduleAnAppointment: 'Schedule an appointment',
	ScheduleOnline: 'Schedule Online',
	Share: 'Share',
	// Menu
	NavMenu: 'Nav Menu',
	PrimaryLocation: 'Primary Location',
	GetDirections: 'Get Directions',
	AcceptedInsurance: 'Accepted Insurance',
	// Locations
	FindALocation: 'Find a Location',
	Hours: 'GENERAL HOURS*',
	About: 'About',
	ServicesOffered: 'Services Offered',
	AdaComplianceInfo: 'ADA Compliance Info',
	VisitWebsite: 'Visit Website',
	Appointments: 'Appointments',
	Providers: 'Providers',
	HoursVary: '*Hours may vary during holidays.  Please call to confirm.',
};
